module.exports = __webpack_public_path__ + "static/img05-020b14a4432c2d19b72f1268ceb80709.png";